import React, { useEffect } from "react";
import { ComponentContainer, GalleryContainer } from "../styled.js";
import { useLanguage } from "../i18n/LanguageContext";

const Gallery = () => {
  const { t } = useLanguage();
  useEffect(() => {
    // Load Curator.io script
    const script = document.createElement("script");
    script.async = true;
    script.charset = "UTF-8";
    script.src = "https://cdn.curator.io/published/687894ed-6f76-445b-9873-4414d2d2167a.js";
    document.head.appendChild(script);

    let hasHiddenBranding = false; // Flag to prevent repeated hiding

    const hideCuratorBranding = () => {
      try {
        // Only search within the curator feed container
        const feedContainer = document.getElementById('curator-feed-default-feed-layout');
        if (!feedContainer || hasHiddenBranding) return;

        // Check if posts are loaded
        const posts = feedContainer.querySelectorAll('.crt-post');
        if (posts.length === 0) return; // Wait for posts to load

        let hiddenCount = 0;

        // Method 1: Hide the second post (which is usually the branding post)
        if (posts.length >= 2) {
          posts[1].style.display = 'none';
          hiddenCount++;
        }

        // Method 2: Target any remaining branding elements by powered-by
        const brandingDivs = feedContainer.querySelectorAll('div[style*="powered-by"]');
        brandingDivs.forEach(div => {
          let parent = div.closest('.crt-post');
          if (parent && parent.style.display !== 'none') {
            parent.style.display = 'none';
            hiddenCount++;
          }
        });

        // Method 3: Target curator.io links
        const curatorLinks = feedContainer.querySelectorAll('a[href*="curator.io"]');
        curatorLinks.forEach(link => {
          let parent = link.closest('.crt-post');
          if (parent && parent.style.display !== 'none') {
            parent.style.display = 'none';
            hiddenCount++;
          }
        });

        if (hiddenCount > 0) {
          hasHiddenBranding = true;
        }

      } catch (error) {
        console.log('Error hiding curator branding:', error);
      }
    };

    // Load the script first
    script.onload = () => {
      // Start checking for branding after script loads
      setTimeout(hideCuratorBranding, 1000);
    };

    // Set up limited checking for branding (only if not already hidden)
    const interval = setInterval(() => {
      if (!hasHiddenBranding) {
        hideCuratorBranding();
      }
    }, 2000); // Check every 2 seconds until branding is hidden

    // Also run immediately
    hideCuratorBranding();

    // Cleanup
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div id="pix">
      <ComponentContainer>
        <GalleryContainer>
          <br />
          <br />
          <h2>{t.gallery.heading}</h2>
          <div id="curator-feed-default-feed-layout" />
        </GalleryContainer>
      </ComponentContainer>
    </div>
  );
};

export default Gallery;
